import React from "react";

export default function Add({ fill = "white", width = "12", height = "12", ...others }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...others}
      >
      <path
        d='M6.94737 0.947368C6.94737 0.696111 6.84756 0.455144 6.66989 0.277478C6.49222 0.0998118 6.25126 0 6 0C5.74874 0 5.50778 0.0998118 5.33011 0.277478C5.15244 0.455144 5.05263 0.696111 5.05263 0.947368V5.05263H0.947368C0.696111 5.05263 0.455144 5.15244 0.277478 5.33011C0.0998118 5.50778 0 5.74874 0 6C0 6.25126 0.0998118 6.49222 0.277478 6.66989C0.455144 6.84756 0.696111 6.94737 0.947368 6.94737H5.05263V11.0526C5.05263 11.3039 5.15244 11.5449 5.33011 11.7225C5.50778 11.9002 5.74874 12 6 12C6.25126 12 6.49222 11.9002 6.66989 11.7225C6.84756 11.5449 6.94737 11.3039 6.94737 11.0526V6.94737H11.0526C11.3039 6.94737 11.5449 6.84756 11.7225 6.66989C11.9002 6.49222 12 6.25126 12 6C12 5.74874 11.9002 5.50778 11.7225 5.33011C11.5449 5.15244 11.3039 5.05263 11.0526 5.05263H6.94737V0.947368Z'
        fill={fill}
      />
    </svg>
  );
}
